class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class MegaMenu extends HTMLElement {
  constructor() {
    super();
    this.headerWrapper = document.querySelector('sticky-header');
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll('summary[data-menu-summary]')
        .forEach(menuItem => menuItem.addEventListener('mouseenter', this.onMenuItemEnter.bind(this)));

    this.headerWrapper.addEventListener('mouseleave', this.closeSubMenus.bind(this));
    this.querySelectorAll('[data-menu-overlay]')
        .forEach(menuItem => menuItem.addEventListener('mouseenter', this.closeSubMenus.bind(this)));
  }

  onMenuItemEnter(event) {
    this.closeSubMenus();
    const toOpen = event.target.closest('details');
    if(toOpen) toOpen.open = true;
  }


  closeSubMenus() {
    this.querySelectorAll('details').forEach(menuWrapper => {
      menuWrapper.open = false
    });
  }


}

customElements.define('mega-menu', MegaMenu);
